import Vue from 'vue'
import Router from 'vue-router'
import Vuex from 'vuex'
import axios from 'axios'
import VueCookies from 'vue-cookies'

Vue.use(Vuex)
Vue.use(Router)
Vue.use(VueCookies)

const applySession = (data) => {
    sessionStorage.setItem('expires', new Date(new Date().getTime() + (1000 * 60 * 120)))
    sessionStorage.setItem('dvUserName', data.dvUserName)
    sessionStorage.setItem('dvUserID', data.dvUserID)
    sessionStorage.setItem('dvApprYN1', data.dvApprYN1)
}

const requireAuth = () => (from, to, next) => {
    axios.get(`/api/member/loginCheck`).then(({ data }) => {
        if (data.result) {
            applySession(data)
            return next()
        }
        next(`/login?redirectUrl=${window.location.pathname}`)
    }).catch(() => {
        next(`/login?redirectUrl=${window.location.pathname}`)
    })
}

const isLogined = () => (from, to, next) => {
    let params = new URLSearchParams(location.search)
    axios.get(`/api/member/loginCheck`).then(({ data }) => {
        if (data.result) {
            applySession(data)
            if (params.get('redirectUrl') !== null && params.get('redirectUrl') !== '/') {
                next(params.get('redirectUrl'))
            } else {
                next(`/invoice`)
            }
            return
        }
        return next()
    }).catch(() => next())
}

/** 헤더·메뉴 없이 NotFound만 표시하는 catch-all 라우트 */
const notFoundRoute = (extra = {}) => ({
    path: '*',
    component: () =>
        import ('../views/notFound'),
    beforeEnter: requireAuth(),
    meta: { bare: true },
    ...extra,
})

export default new Router({
    linkActiveClass: 'active',
    mode: 'history',
    routes: [{
            path: '/login',
            name: 'Login',
            component: () =>
                import ('../views/login'),
            beforeEnter: isLogined()
        },
        {
            path: '/',
            name: 'Root',
            component: () =>
                import ('../views/login'),
            beforeEnter: isLogined()
        },
        {
            path: '/code',
            name: 'Code',
            redirect: '/code/standard',
            component: { render: h => h('router-view') },
            children: [{
                    path: 'standard/:id(\\d+)?/:tab(code)?/:childId(\\d+)?',
                    name: 'Code.standard',
                    component: () =>
                        import ('../views/code/standard'),
                    beforeEnter: requireAuth(),
                },
                {
                    path: 'general/:id(\\d+)?/:tab(code)?/:childId(\\d+)?',
                    name: 'Code.general',
                    component: () =>
                        import ('../views/code/general'),
                    beforeEnter: requireAuth(),
                },
                {
                    path: 'division/:id(\\d+)?',
                    name: 'Code.division',
                    component: () =>
                        import ('../views/code/division'),
                    beforeEnter: requireAuth(),
                },
                notFoundRoute(),
            ]
        },
        {
            path: '/company',
            name: 'Company',
            redirect: '/company/importer',
            component: { render: h => h('router-view') },
            children: [{
                    path: 'importer/:id(\\d+)?',
                    name: 'Company.importer',
                    component: () =>
                        import ('../views/company/importer'),
                    beforeEnter: requireAuth(),
                },
                {
                    path: 'exporter/:id(\\d+)?',
                    name: 'Company.exporter',
                    component: () =>
                        import ('../views/company/exporter'),
                    beforeEnter: requireAuth(),
                },
                notFoundRoute(),
            ]
        },
        {
            path: '/item',
            name: 'Item',
            redirect: '/item/item',
            component: { render: h => h('router-view') },
            children: [{
                    path: 'item/:id?',
                    name: 'Item.item',
                    component: () =>
                        import ('../views/item/item'),
                    beforeEnter: requireAuth()
                },
                {
                    path: 'upn/:id(\\d+)?',
                    name: 'Item.upn',
                    component: () =>
                        import ('../views/item/upn'),
                    beforeEnter: requireAuth()
                },
                {
                    path: 'trust/:id(\\d+)?',
                    name: 'Item.trust',
                    component: () =>
                        import ('../views/item/trust'),
                    beforeEnter: requireAuth()
                },
                {
                    path: 'unitprice/:id(\\d+)?',
                    name: 'Item.unitprice',
                    component: () =>
                        import ('../views/item/unitprice'),
                    beforeEnter: requireAuth(),
                },
                notFoundRoute(),
            ]
        },
        {
            path: '/license/:id(\\d+)?/:tab(upn)?/:childId(\\d+)?',
            name: 'License',
            component: () =>
                import ('../views/license'),
            beforeEnter: requireAuth()
        },
        {
            path: '/invoice/:id(\\d+)?/:tab(upn)?/:childId(\\d+)?',
            name: 'Invoice',
            component: () =>
                import ('../views/invoice'),
            beforeEnter: requireAuth()
        },
        {
            path: '/document/:id(\\d+)?/:tab(item)?/:childId(\\d+)?',
            name: 'Document',
            component: () =>
                import ('../views/document'),
            beforeEnter: requireAuth()
        },
        {
            path: '/modify/:id(\\d+)?',
            name: 'Modify',
            component: () =>
                import ('../views/modify'),
            beforeEnter: requireAuth()
        },
        {
            path: '/stats',
            name: 'Stats',
            redirect: '/stats/document',
            component: { render: h => h('router-view') },
            children: [{
                    path: 'document',
                    name: 'Stats.document',
                    component: () =>
                        import ('../views/stats/document'),
                    beforeEnter: requireAuth()
                },
                notFoundRoute(),
            ]
        },
        notFoundRoute({ name: 'NotFound' }),
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js